export default function SelectLanguage(selector) {
  const select = document.querySelector(selector);
  if (!select) return;

  const pageLanguage = document.documentElement.lang;
  const selectedLanguage = select.value;
  const languages = {
    'ja': 'jp/asicsfoundation',
    'en': 'en/asicsfoundation',
  };

  console.log(selectedLanguage);
  console.log(pageLanguage);
  // ページの言語と選択された言語が異なる場合、select要素の選択されているオプションを、ページの言語に合わせる
  if (selectedLanguage !== pageLanguage) {
    select.value = pageLanguage;
  }

  // select要素の変更イベントを監視
  select.addEventListener('change', (event) => {
    const selectedValue = event.target.value;
    const selectedLanguage = languages[selectedValue];
    console.log(selectedLanguage);
    // 選択された言語に基づいてページをリダイレクト
    if (selectedLanguage) {
      window.location.href = `/${selectedLanguage}/`;
    }
  });
  // ページの言語に合わせてselect要素の選択されているオプションを変更
  select.value = pageLanguage;
}